const PRINT_DESIGN_FILE_EXTENSIONS = ["ai"];

export const isPrintDesignFileExtension = (fileExtension: string) => {
  return PRINT_DESIGN_FILE_EXTENSIONS.includes(fileExtension.toLowerCase());
};

export const isPrintDesignFileName = (fileName: string) => {
  const fileExtension = fileName.split(".").pop();
  if (!fileExtension) {
    return false;
  }
  return isPrintDesignFileExtension(fileExtension);
};
